module.exports = __webpack_public_path__ + "static/img/OC_bg05.8b58dc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/runtime/components/assets/OC_bg05.png
// module id = L4Dw
// module chunks = 7